export default __webpack_public_path__ + "static/media/theofil.ecf60767.jpg";